import { render, staticRenderFns } from "./rolesAuthority.vue?vue&type=template&id=f2b5196a&scoped=true&"
import script from "./rolesAuthority.vue?vue&type=script&lang=ts&"
export * from "./rolesAuthority.vue?vue&type=script&lang=ts&"
import style0 from "./rolesAuthority.vue?vue&type=style&index=0&id=f2b5196a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b5196a",
  null
  
)

export default component.exports